import React from "react";

export default function LLMStatus() {
  return (
    <div style={{ padding: 40, textAlign: "center", color: "#999", fontSize: 14 }}>
      LLM Status Tracker — coming soon
    </div>
  );
}
